module.exports = __webpack_public_path__ + "assets/img/12.5f42243a.jpg";